<template>
	<div v-if="canInviteUsers" class="confirmation-dialog display-flex flex-column" :class="{ disable: sendingInviteAndShare }">
		<Loader v-if="sendingInviteAndShare" :isAbsoluteCenter="true" />

		<div class="send-email-invitation-title">You are about to invite the following users to your workspace:</div>
		<div class="email-list-box mt-1">
			<div v-for="emailToInvite in emailsToInvite" :key="emailToInvite">
				<ChipOfContacts :item="emailToInvite" :hasClose="false"> </ChipOfContacts>
			</div>
		</div>
		<div class="flex-1 flex-end--center flex-column">
			<v-btn class="btn btn-primary" @click="$emit('onShareClicked')" :disabled="sendingInviteAndShare">Invite and {{ nounText }}</v-btn>
			<div class="link-style dark mt-1" @click="$emit('onBackClicked')">Back</div>
		</div>
	</div>
	<div v-else class="confirmation-dialog" :class="{ disable: sendingInviteAndShare }">
		<Loader v-if="sendingInviteAndShare" :isAbsoluteCenter="true" />

		<div class="send-email-invitation-title-not-owner">You do not have permissions to invite users to this workspace.</div>
		<div class="not-send-email-invitation-title">The following users will <span class="not">NOT</span> be invited to your workspace:</div>
		<div class="email-list-box mt-1">{{ emailsToInvite.join(', ') }}</div>
		<div class="flex-1 flex-end--center flex-column">
			<v-btn class="btn btn-primary mt-2" @click="$emit('onShareClicked')" :disabled="nonAccountOwnerAllowShare">
				{{ capitalizedNounText }} with {{ usersSelectedCount }} others
			</v-btn>
			<div class="link-style dark mt-1" @click="$emit('onBackClicked')">Back</div>
		</div>
	</div>
</template>

<script>
import ChipOfContacts from './ChipOfContacts';
import { capitalizeWord } from '@/utils/language-service';

export default {
	name: 'InvitationConfirmations',
	components: { ChipOfContacts },
	props: {
		canInviteUsers: { type: Boolean },
		isProject: { type: Boolean },
		emailsToInvite: { type: Array },
		sendingInviteAndShare: { type: Boolean },
		nonAccountOwnerAllowShare: { type: Boolean },
		usersSelectedCount: { type: Number },
	},
	computed: {
		nounText() {
			return this.isProject ? 'collaborate' : 'share';
		},
		capitalizedNounText() {
			return capitalizeWord(this.nounText);
		},
	},
};
</script>

<style scoped lang="scss">
.confirmation-dialog {
	min-height: inherit;
	padding: 20px 30px;

	&.disable {
		pointer-events: none;
		opacity: 0.3;
	}

	.email-list-box {
		padding: 10px 15px;
		border: var(--primary-border);
		border-radius: 7px;
		padding: 20px 30px;
		max-height: 50vh;
		overflow: auto;

		> div:not(:last-child) {
			margin: 0 0 10px 0;
		}
	}
	.send-email-invitation-title {
		margin: 0 0 10px 0;
		font-size: 16px;
		font-weight: 500;
	}
	.not-send-email-invitation-title {
		margin: 0 0 10px 0;
		font-size: 14px;
		font-weight: 400;
		.not {
			font-size: 16px;
			font-weight: 500;
		}
	}
	.send-email-invitation-title-not-owner {
		margin: 0 10px 0 0;
		font-size: 12px;
		opacity: 0.5;
	}
}
</style>
